import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { HELPFUL, MARKETPLACES } from '../lib/constants';
import DefaultCategoriesFeatured from './DefaultCategoriesFeatured';
import DefaultCategoriesHelpful from './DefaultCategoriesHelpful';
import DefaultCategoriesListCards from './DefaultCategoriesListCards';
import getContent from '../lib/dictionaryFetcher';
import Discover from './Discover';

/**
 * render all the categories for desktop or laptop screensize.
 * @param {*} props
 */
const DefaultCategoriesList = props => {
  const {
    app,
    activeKey,
    tools,
    toggleFavorite,
    setApp,
    setTool,
    recordClick,
    tracking,
    recommendations,
    title,
    categories,
    categoryIndexes,
    category,
    featured,
    experimentation,
    changeTab,
    favorites
  } = props;

  const user = get(app, 'context.user', {}),
    categoryName = get(category, 'name', '');

  const renderApps = () => {
    return categoryName === 'discover' ? (
      <Discover
        category={category}
        categoryIndexes={categoryIndexes}
        categories={categories}
        user={user}
        tools={tools}
        setApp={setApp}
        setTool={setTool}
        toggleFavorite={toggleFavorite}
        changeTab={changeTab}
        favorites={favorites}
        featured={featured}
        recommendations={recommendations}
        app={app}
      />
    ) : (
      <DefaultCategoriesListCards
        category={category}
        user={user}
        tools={tools}
        setApp={setApp}
        setTool={setTool}
        toggleFavorite={toggleFavorite}
      />
    );
  };

  const sharedProps = { app, tracking, recordClick };
  const commonProps = {
    activeKey,
    categories,
    category: categoryName,
    callback: setApp
  };

  const helpful = get(HELPFUL, categoryName, ''),
    isHawk = get(app, 'type', '').toLowerCase() === 'business',
    isElmo = get(experimentation, helpful, false),
    otss = get(app, 'context.user.eligibility.otss', []),
    hasPartner = otss.includes(helpful),
    shouldDisplay = helpful && isHawk && isElmo && hasPartner,
    isDiscoverTab = categoryName === 'discover',
    items = get(category, 'items', []);

  const isMarketplace = items.every(val => MARKETPLACES.includes(val)),
    marketplaceTitle = isMarketplace
      ? getContent('merchanthub', `categories.title.${categoryName}`, title)
      : title,
    featuredMarketplaceTitle = getContent(
      'merchanthub',
      `categories.title.featured.${categoryName}`,
      ''
    );

  const heading = featured[categoryName]
    ? featuredMarketplaceTitle
    : marketplaceTitle;

  return (
    <div id="tools-list" className={`tools-list-${categoryName}`}>
      <DefaultCategoriesFeatured
        {...sharedProps}
        {...commonProps}
        featured={featured[categoryName]}
      />
      {items.length > 0 && !isDiscoverTab && (
        <h2 className="tools-category-heading">{heading}</h2>
      )}
      {renderApps()}
      {shouldDisplay && (
        <DefaultCategoriesHelpful
          {...sharedProps}
          {...commonProps}
          helpful={helpful}
        />
      )}
    </div>
  );
};

DefaultCategoriesList.propTypes = {
  app: PropTypes.object,
  activeKey: PropTypes.string,
  toggleFavorite: PropTypes.func,
  setApp: PropTypes.func,
  setTool: PropTypes.func,
  tools: PropTypes.object,
  recordClick: PropTypes.func,
  tracking: PropTypes.object,
  recommendations: PropTypes.array,
  title: PropTypes.string,
  category: PropTypes.object,
  featured: PropTypes.object,
  categories: PropTypes.array,
  categoryIndexes: PropTypes.object,
  experimentation: PropTypes.object,
  changeTab: PropTypes.func,
  favorites: PropTypes.array
};

export default DefaultCategoriesList;
